import { LuIcon, Menu, type MenuMultiSelectGroupProps, Text } from "@overmap-ai/blocks"
import type { User } from "@overmap-ai/common"
import { memo } from "react"

import { modelIconMapping } from "../../mappings/icons"
import { getUserDisplayLabel } from "../../utils/users"
import { UserIcon } from "../Icons/UserIcon"
import { MultiSelectItemTemplate, SelectAllItemTemplate } from "../MenuGroups/constants"

export interface AssigneeMultiSelectGroupProps extends MenuMultiSelectGroupProps<User | null> {
	users: (User | null)[]
}

export const AssigneeMultiSelectGroup = memo<AssigneeMultiSelectGroupProps>((props) => {
	const { ref, users, ...rest } = props

	return (
		<Menu.MultiSelectGroup<User | null> ref={ref} {...rest}>
			<SelectAllItemTemplate>Select all</SelectAllItemTemplate>
			{users.map((user) => {
				return (
					<MultiSelectItemTemplate<User | null> key={user?.id ?? "unassigned"} value={user}>
						{user ? (
							<>
								<UserIcon userId={user.id} size="xs" />
								<Text className="truncate">{getUserDisplayLabel(user)}</Text>
							</>
						) : (
							<>
								<LuIcon icon={modelIconMapping.unassigned} />
								<span className="truncate">Unassigned</span>
							</>
						)}
					</MultiSelectItemTemplate>
				)
			})}
		</Menu.MultiSelectGroup>
	)
})
AssigneeMultiSelectGroup.displayName = "AssigneeMultiSelectGroup"
